// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `airportdetailscard .searchbar-input {
  padding: 4px 50px !important;
  height: auto;
  border-radius: 2px;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1rem !important;
  background-position: 8px center;
  box-shadow: none;
}
airportdetailscard .searchbar-search-icon {
  top: 4px !important;
  left: 12px !important;
  width: 16px !important;
  height: 18px !important;
}
airportdetailscard .smallPara {
  font-size: 11px;
}
airportdetailscard .segment-button {
  font-weight: normal;
}
airportdetailscard .Legitem {
  min-height: 3.2rem;
  font-size: 11px;
}
airportdetailscard .capsLeg {
  font-size: 20px;
}
airportdetailscard .smallLeg {
  font-size: 10px;
}
airportdetailscard .paraInfo {
  font-size: 14px;
}
airportdetailscard .segmentview .segment ion-segment-button.segment-button {
  flex: 1 0 95px;
  height: 5rem;
  line-height: 5rem;
  text-transform: none;
}
airportdetailscard .segment-card {
  margin-left: 0;
  margin-top: 0;
}
airportdetailscard .mapview {
  border-bottom: none !important;
}
airportdetailscard .mapview.activated,
airportdetailscard .mapview-activated {
  border-bottom: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/airportmapview/airportmapview.page.scss"],"names":[],"mappings":"AACI;EACE,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EAGA,+BAAA;EACA,gBAAA;AAFN;AAKI;EACE,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;AAHN;AAMI;EACE,eAAA;AAJN;AAOI;EAEE,mBAAA;AANN;AASI;EACE,kBAAA;EACA,eAAA;AAPN;AAUI;EACE,eAAA;AARN;AAYI;EACE,eAAA;AAVN;AAcI;EACE,eAAA;AAZN;AAyBI;EAIE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAvBN;AA+BI;EACE,cAAA;EACA,aAAA;AA7BN;AAgCI;EACE,8BAAA;AA9BN;AAiCI;;EAEE,8BAAA;AA/BN","sourcesContent":["airportdetailscard {\n    .searchbar-input {\n      padding: 4px 50px !important;\n      height: auto;\n      border-radius: 2px;\n      font-size: 1.6rem;\n      font-weight: 400;\n      line-height: 1rem !important;\n    //   color: map_get($colors, primary);\n    //   background-color: map_get($colors, content-background);\n      background-position: 8px center;\n      box-shadow: none;\n    }\n  \n    .searchbar-search-icon {\n      top: 4px !important;\n      left: 12px !important;\n      width: 16px !important;\n      height: 18px !important;\n    }\n  \n    .smallPara {\n      font-size: 11px;\n    }\n  \n    .segment-button {\n    //   color: map_get($colors, primary);\n      font-weight: normal;\n    }\n  \n    .Legitem {\n      min-height: 3.2rem;\n      font-size: 11px;\n    }\n  \n    .capsLeg {\n      font-size: 20px;\n    //   color: map_get($colors, primary);\n    }\n  \n    .smallLeg {\n      font-size: 10px;\n    //   color: map_get($colors, primary);\n    }\n  \n    .paraInfo {\n      font-size: 14px;\n    //   color: map_get($colors, primary);\n    }\n  \n    // .CustomSeg {\n    //     -webkit-box-flex: 1;\n    //     -webkit-flex: 0 0 0px;\n    //     -ms-flex: 0 0 0px;\n    //     flex: 0 0 0px;\n    //     height: 6.5rem;\n    //     line-height: 0.5rem;\n    // }\n  \n    .segmentview .segment ion-segment-button.segment-button {\n      -webkit-box-flex: 1;\n      -webkit-flex: 1 0 95px;\n      -ms-flex: 1 0 95px;\n      flex: 1 0 95px;\n      height: 5rem;\n      line-height: 5rem;\n      text-transform: none;\n    }\n  \n    .segment-header {\n    //   background-color: map_get($colors, primary);\n    //   color: map_get($colors, content-background);\n    }\n  \n    .segment-card {\n      margin-left: 0;\n      margin-top: 0;\n    }\n  \n    .mapview {\n      border-bottom: none !important;\n    }\n  \n    .mapview.activated,\n    .mapview-activated {\n      border-bottom: none !important;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
